@import "scss-variables";

.depositing-vessels {
  .title {
    position: relative;
    color: white;
    width: 100%;
    text-shadow: 0px 2px 0px #000;

    img {
      position: absolute;
      top: -2px;
      right: 0;
      height: 100%;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    color: #fff;
    text-align: center;
    font-family: "More Sugar";
    font-size: 1.5rem;
    line-height: 1rem;
    letter-spacing: -0.05rem;
    padding-top: 1rem;

    .total {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      font-size: 2rem;

      img {
        height: 3rem;
      }
    }

    .count {
      display: flex;
      justify-content: center;
      gap: 2rem;

      .label {
        background-color: #db43a3;
        padding: 1rem;
        border-radius: 2rem;
      }
    }

    .done {
      margin-top: 1rem;
    }
  }
}
